module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"warningMessage":"You have unsaved changes!"},"it":{"warningMessage":"Hai apportato modifiche che devono essere salvate!"}}')
  delete Component.options._Ctor
}
